export const contracts = {
  contract: 'Szerződés',
  deleteTitle: 'Szerződés törlése',
  deleteMessage: 'Biztosan törölni szeretné ezt a szerződést?',
  deleteWarning: 'Ez a művelet nem visszavonható.',
  bulkDelete: 'Csoportos törlés',
  bulkDeleteTitle: 'Szerződések törlése',
  bulkDeleteMessage: 'Biztosan törölni szeretné a kiválasztott {{count}} szerződést?',
  bulkDeleteWarning: 'Ez a művelet nem visszavonható, és az összes kiválasztott szerződést törli.',
  selected: 'elem kiválasztva',
  title: 'Dokumentumok',
  placeholder: {
    search: 'Keresés...',
  },
  filter: {
    allTypes: 'Összes típus',
    contract: 'Szerződés',
    quotation: 'Árajánlat',
    other: 'Egyéb',
    allCustomers: 'Összes ügyfél',
    searchCustomer: 'Ügyfél keresése...',
    unknownCustomer: 'Ismeretlen ügyfél',
    showFilters: 'Szűrők megjelenítése',
    hideFilters: 'Szűrők elrejtése'
  },
  fields: {
    name: 'Név',
    client: 'Ügyfél',
    customer: 'Ügyfél',
    type: 'Típus',
    createdAt: 'Létrehozás dátuma',
    status: 'Státusz',
    actions: 'Műveletek',
    validStart: 'Érvényesség kezdete',
    validEnd: 'Érvényesség vége',
    views: 'Megtekintések',
    organization: 'Szervezet'
  },
  setAsValid: 'Beállítás érvényesként',
  setAsExpired: 'Beállítás lejártként',
  setAsDraft: 'Beállítás piszkozatként',
  changeExcel: 'Excel fájl módosítása',
  types: {
    contract: 'Szerződés',
    quotation: 'Árajánlat',
    other: 'Egyéb',
  },
  status: {
    draft: 'Piszkozat',
    valid: 'Érvényes',
    expired: 'Lejárt',
  },
  noContracts: 'Nincsenek megjeleníthető szerződések',
  newContract: 'Új dokumentum létrehozása',
  newTemplate: 'Új szerződés sablon',
  generateContract: 'Szerződés generálása',
  selectDocumentType: 'Dokumentum típus kiválasztása',
  generateContractForClients: 'Szerződés generálása ügyfeleknek',
  generateQuotation: 'Árajánlat generálása',
  generateOtherDocument: 'Egyéb dokumentum generálása',
  importData: 'Adatok importálása',
  importExcel: 'Excel fájl importálása',
  importDataDescription: 'Adatok importálása az Excel fájlból',
  importedData: 'Adatok importálva',
  selectedTemplate: 'Kiválasztott szerződés sablon',
  selectedTemplateDescription: 'Az alábbi szerződés sablon lesz használva a generáláshoz',
  contractUpdatedAt: 'Szerződés frissítve',
  updatedAt: 'Frissítve',
  generateDocument: 'Dokumentum generálása',
  selectedContract: 'Kiválasztott szerződés',
  selectedFormats: 'formátum kiválasztva',
  generating: 'Generálás folyamatban...',
  generatingDocument: 'Dokumentum generálása folyamatban...',
  generatedDocument: 'Dokumentum generálva',
  generatedDocumentError: 'Hiba történt a dokumentum generálása közben',
  generatedDocumentSuccess: 'Dokumentum sikeresen létrehozva',
  generateLoadDataFrom: "A szerződés generálásához adatokat tölthetsz be Excel fájlból vagy manuálisan",
  noDataError: "Nincs adat a dokumentum generálásához. Kérjük, tölts be adatokat Excel fájlból vagy add meg manuálisan.",
  emptyDataError: "Az adatkészlet üres. Kérjük, tölts be érvényes adatokat.",
  importExcelModal: {
    title: 'Excel fájl importálása',
    description: 'Válassz ki egy Excel fájlt, amely tartalmazza az adatokat a szerződések generálásához. A fájlnak tartalmaznia kell minden szükséges mezőt, amit a sablonban használni szeretnél.',
    selectFile: 'Fájl kiválasztása',
    supportedFormats: 'Támogatott formátumok: .xlsx, .xls, .csv',
    cancel: 'Mégse',
    preview: 'Importált adatok előnézete',
    import: 'Importálás',
  },
  chooseTemplateModal: {
    title: 'Sablon kiválasztása',
    description: 'Válassz ki egy sablont a generáláshoz.',
    outputFormats: 'Kimeneti formátumok',
    outputFormatsDescription: 'Válaszd ki a generálandó formátumokat (több is választható)',
    selectTemplate: 'Sablon kiválasztása',
    searchTemplate: 'Sablon keresése',
    newestFirst: 'Legfrissebb elől',
    oldestFirst: 'Legrégebbi elől',
    nameAsc: 'Név (A-Z)',
    nameDesc: 'Név (Z-A)',
    preview: 'Előnézet',
    noTemplatesFound: 'Nincs találat a keresési feltételekre',
    noTemplatesAvailable: 'Nincs elérhető sablon ehhez a típushoz',
    select: 'Kiválasztás'
  },
  documentPreviewModal: {
    title: 'Dokumentum előnézet',
    documentNotFound: 'A dokumentum nem található vagy nem érhető el.',
    documentNotDisplayable: 'A dokumentum nem jeleníthető meg',
    download: 'Letöltés',
    reload: 'Frissítés',
    openInNewTab: 'Megnyitás új lapon',
    documentInformation: 'Dokumentum információk',
    showDetails: 'Részletek mutatása',
    hideDetails: 'Elrejtés',
  },
  manualFill: {
    title: 'Adatok kézi kitöltése',
    editTitle: 'Importált adatok szerkesztése',
    description: 'Add meg az adatokat kézzel a sablonhoz. Több adatsort is hozzáadhatsz.',
    editDescription: 'Az importált Excel adatok szerkesztése. Módosíthatod az értékeket és új adatsorokat is hozzáadhatsz.',
    noFields: 'Nincsenek mezők a sablonban.',
    fieldPlaceholder: 'Érték megadása...',
    addNewDataSet: 'Új adatsor hozzáadása',
    button: "Kézi kitöltés",
    dataRow: "Adatsor:",
    removeDataSet: "Adatsor törlése"
  },
  actions: {
    view: "Megnézem",
    download: "Letöltöm",
    share: "Megosztás",
    delete: "Törlöm"
  },
  shared: "A link másolva a vágólapra!",
  shareModal: {
    title: "Dokumentum megosztása",
    passwordProtection: "Jelszavas védelem",
    password: "Jelszó",
    validUntil: "Érvényesség vége (opcionális)",
    createLink: "Link létrehozása",
    updateLink: "Link frissítése",
    linkCreated: "Megosztási link létrehozva:",
    copyLink: "Link másolása",
    linkInfo: "Bárki, aki rendelkezik ezzel a linkkel, megtekintheti a dokumentumot.",
    linkPasswordInfo: "Ez a link jelszóval védett. A címzettnek meg kell adnia a jelszót a megtekintéshez.",
    editLink: "Link szerkesztése",
    cancelEdit: "Szerkesztés visszavonása",
    modifySharing: "Megosztás módosítása",
    viewStats: "Megtekintési statisztikák",
    shareSuccessful: "Megosztás sikeres!",
    linkExpiry: "Link lejárati ideje"
  },
  messages: {
    deleted: 'Szerződés sikeresen törölve',
    deleteError: 'Hiba történt a szerződés törlése közben',
    bulkDeleted: '{{count}} szerződés sikeresen törölve',
  },
  documentLoadError: 'Hiba történt a dokumentum betöltése közben',
  tryDownloadInstead: 'Kérjük, próbálja meg letölteni a dokumentumot a közvetlen megtekintés helyett',
  browserCannotDisplay: 'A böngésző nem tudja megjeleníteni ezt a PDF dokumentumot. Kérjük, töltse le és nyissa meg külső programmal.',
  viewCount: '{{count}} megtekintés',
  lastViewed: 'Utoljára megtekintve',
  filterNoResults: 'Nincs a szűrési feltételeknek megfelelő dokumentum. Próbálja módosítani a keresési feltételeket.',
  emptyState: 'Még nem hozott létre dokumentumokat. Kezdje el az első dokumentum létrehozásával.',
  clearSearch: 'Keresés törlése',
  clearTypeFilter: 'Típus szűrő törlése',
  clearCustomerFilter: 'Ügyfél szűrő törlése'
}
